module.exports = __webpack_public_path__ + "static/media/Casino-Days-Logo-Two-Lines-Gradient-Text-600x372.021a1bb9.png";